/* eslint-disable max-len */
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import CustomReactRouter7Adapter from '../utilities/custom_react_router_7_adapter';
import PropTypes from 'prop-types';
import NewsletterSubscription from '../components/react/newsletter_subscription/newsletter_subscription';
import UnsubscribeNewsletter from './components/unsubscribe_newsletter/unsubscribe_newsletter';
import './newsletters_show.scss';
/* eslint-enable max-len */

const CLOUDINARY_PATH =
  'https://res.cloudinary.com/devex/image/fetch/c_fill,f_auto,g_faces,h_450,w_425,q_auto:eco';

const NewslettersShow = ({ newsletter, isSignedIn = false }) => {
  return (
    <div
      data-testid='newsletter-show'
      className={`
        newsletter-signup-page-form text-center
        d-md-flex justify-content-center
        align-items-center mt-5 mb-5
        ${newsletter.accent_color ? newsletter.accent_color : 'orange-theme'}
      `}
    >
      <div className='image-container'>
        <div className='small-devices-text d-block d-sm-block d-md-none'>
          <i
            className={`icon fal icon-${newsletter.icon}`}
            role='img'
            aria-label='newsletter icon'
          ></i>
          <h1 className='fw-bold mb-0'>{newsletter.name}</h1>
        </div>
        <span className='image-content'>
          {newsletter.logo ? (
            <img
              className='img-fluid'
              aria-label='newsletter logo'
              src={`${CLOUDINARY_PATH}/${newsletter.logo}`}
            />
          ) : (
            <img
              className='img-fluid'
              aria-label='newsletter logo'
              src={`${CLOUDINARY_PATH}/membership-landing-1346610aa8285d7082f14e5af2763b0b.jpg`}
            />
          )}
        </span>
      </div>
      <div className='text-container text-center'>
        <BrowserRouter>
          <QueryParamProvider adapter={CustomReactRouter7Adapter}>
            <Routes>
              <Route
                path='/newsletters/:slug/unsubscribe'
                element={<UnsubscribeNewsletter newsletter={newsletter} />}
              />
              <Route
                path='/newsletters/:slug'
                element={
                  <NewsletterSubscription
                    newsletter={newsletter}
                    isSignedIn={isSignedIn}
                    hideIfSubscribed={false}
                  />
                }
              />
            </Routes>
          </QueryParamProvider>
        </BrowserRouter>
      </div>
    </div>
  );
};

NewslettersShow.propTypes = {
  newsletter: PropTypes.shape({
    id: PropTypes.number.isRequired,
    icon: PropTypes.string,
    logo: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    accent_color: PropTypes.string,
  }),
  isSignedIn: PropTypes.bool,
};

export default NewslettersShow;
